import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { CentralServerService } from '@services/central-server.service';
import { inject } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StatusCodes } from 'http-status-codes';
import { MessageService } from '@services/message.service';
import { HTTPError } from '../../types/HTTPError';

export const SKIP_AUTO_DISCONNECT = new HttpContextToken<boolean>(() => false);

export class AutoDisconnectInterceptor implements HttpInterceptor {
  private readonly SHOW_WARNING_ERROR_CODES = [HTTPError.ERROR_595, HTTPError.TENANT_COMPONENT_CHANGED];
  private readonly AUTO_DISCONNECT_ERROR_CODES = [StatusCodes.UNAUTHORIZED, ...this.SHOW_WARNING_ERROR_CODES];

  private readonly centralServerService = inject(CentralServerService);
  private readonly messageService = inject(MessageService);

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (req.context.get(SKIP_AUTO_DISCONNECT)) {
          return throwError(() => error);
        }

        if (!this.AUTO_DISCONNECT_ERROR_CODES.includes(error.status)) {
          return throwError(() => error);
        }

        if (this.SHOW_WARNING_ERROR_CODES.includes(error.status)) {
          this.messageService.showWarningMessageUserOrTenantUpdated();
        }

        this.centralServerService.logout().subscribe();

        // Stop propagation of the error
        return EMPTY;
      }),
    );
  }
}
